var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExperienceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#experience-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.5 22c0 11.874-9.626 21.5-21.5 21.5S.5 33.874.5 22 10.126.5 22 .5 43.5 10.126 43.5 22Z",
  stroke: "#A4ABB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.27 35H10.82c-1.34 0-2.44-1.09-2.44-2.44v-2.58c0-.28.22-.5.5-.5H24.3c.28 0 .5.22.5.5v2.55c0 .81.66 1.47 1.47 1.47.81 0 1.47-.66 1.47-1.47V14.58c0-.28.22-.5.5-.5s.5.22.5.5v17.95c0 1.36-1.11 2.47-2.47 2.47ZM9.38 30.49v2.08c0 .79.64 1.44 1.44 1.44h13.47c-.3-.41-.49-.92-.49-1.47v-2.05H9.38Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.38 30.48c-.28 0-.5-.22-.5-.5V10.42c0-1.46 1.19-2.66 2.66-2.66h9.85c.28 0 .5.22.5.5s-.22.5-.5.5h-9.86c-.91 0-1.66.74-1.66 1.66v19.56c0 .28-.22.5-.5.5h.01Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.212 8.76h-15.45c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h15.45c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.65 32.56c-1.08 0-1.97-.88-1.97-1.97V10.23c0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47v5.09c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-5.09c0-1.36 1.11-2.47 2.47-2.47s2.47 1.11 2.47 2.47v1.04h2.43c.28 0 .5.22.5.5V30.6c0 1.08-.88 1.97-1.97 1.97l.01-.01Zm-.97-20.29V30.6a.97.97 0 0 0 1.94 0V12.28h-1.93l-.01-.01Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.65 32.56h-5.4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5.4c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.19 13.01h-3.61c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3.61c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#F15B35"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.19 22.12h-3.61c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3.61c.28 0 .5.22.5.5s-.22.5-.5.5ZM24.95 15.29h-9.31c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.31c.28 0 .5.22.5.5s-.22.5-.5.5ZM24.95 17.57h-9.31c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.31c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#A4ABB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.95 25.66h-9.31c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.31c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#F15B35"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.95 27.94h-9.31c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.31c.28 0 .5.22.5.5s-.22.5-.5.5ZM24.95 19.85h-9.31c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.31c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#A4ABB7"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "experience-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h44v44H0z"
})))));
export default SvgExperienceIcon;